import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createTermsAndConditionsValidator = (
  context: ValidatorContext
): FieldSchema => {
  const { field, l, isRequired, requiredMessage } = context;

  let validator = Yup.boolean()
    .nullable()
    .typeError(l('You must accept the terms and conditions'));

  if (isRequired && 'isReadOnly' in field && !field.isReadOnly) {
    const message =
      requiredMessage ?? l('You must accept the terms and conditions');

    validator = validator.oneOf([true], message).required(message);
  }

  return validator;
};

export default createTermsAndConditionsValidator;
